import { render } from "./MykwsIcon.vue?vue&type=template&id=5a534c5a"
import script from "./MykwsIcon.vue?vue&type=script&lang=js"
export * from "./MykwsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__